 export const accountConstants={
    stripe_bank :'stripe_bank',
    verified :'verified',
    BANK_ACH :'bankACH',
    CARD : 'card',
    SAVEDCARD: 'savedCard'
 }